import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import Chart from 'chart.js';
axios.defaults.withCredentials = true
Vue.config.productionTip = false
import VueNumericInput from 'vue-numeric-input';

Vue.use(VueNumericInput)
Vue.prototype.axios=axios;
Vue.prototype.Chart=Chart;

new Vue({
  store,
  router,
  vuetify,
  axios,
  Chart,
  /*v_number_input,*/
  render: h => h(App)
}).$mount('#app')
